
const state = {
  currentNativePageData: null // 当前原生页的数据
}
const mutations = {
  setCurrentNativePageData(state, payload) {
    state.currentNativePageData = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
